<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-3" [routerLink]="['/remote-command/sequential-token-load']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">{{ "SEQUENTIALTOKENLOAD_TITLE" | translate }}</h2>
      <p class="col subtitle">{{ "SEQUENTIALTOKENLOAD_SUBTITLE" | translate }}</p>
    </div>
  </div>

  <form #crudform="ngForm" (ngSubmit)="onSubmit()">
    <div class="form-item">
      <label class="form-label" for="meterNo">{{ "DEVICESETUP_METERNO" | translate }}</label>
      <div class="form-input">
        <input
          id="meterNo"
          [(ngModel)]="model.meterNumber"
          #meterNoField="ngModel"
          name="meterNo"
          type="text"
          required
        />
        @if (crudform.submitted && meterNoField.invalid) {
          <div class="validation-error">
            {{ "DEVICESETUP_METERNO" | translate }}{{ "DEVICESETUP_ISREQUIRED" | translate }}.
          </div>
        } @else if (!model.meterNumber) {
          <div class="validation-instruction">
            {{ "DEVICESETUP_METERNODESC" | translate }} {{"METERNO_PLACEHOLDER" | translate}}.
          </div>
        }
      </div>
    </div>

    <div class="horizontal-line"></div>

    <ng-container *ngFor="let token of model.tokens; let i = index">
      <div class="form-item">
        <label class="form-label">{{ "TOKEN" | translate }}</label>
        <div class="form-input">
          <span class="token-number-label">{{ "TOKEN_NUMBER" | translate }} #{{ i + 1 }}</span>
          <div class="token-fields">
            <select [(ngModel)]="token.type" [name]="'tokenType_' + i" required [class.placeholder-shown]="!token.type">
              <option value="" disabled hidden>{{ "TOKEN" | translate }}</option>
              <option *ngFor="let type of tokenTypes" [value]="type">{{ formatTypeLabel(type) }}</option>
            </select>
            <input
              [id]="'token_' + i"
              [(ngModel)]="token.value"
              [name]="'tokenValue_' + i"
              type="text"
              [placeholder]="'TOKEN_DESC' | translate"
              pattern="^(\d{20}|\d{4}([\- ])\d{4}\2\d{4}\2\d{4}\2\d{4})$"
              required
            />
          </div>
          @if (crudform.controls['tokenValue_' + i].invalid && crudform.controls['tokenValue_' + i].touched && crudform.controls['tokenValue_' + i].errors?.['pattern']) {
            <div class="validation-error">
              {{ "CLEARCREDITSETUP_STSTOKENERROR" | translate }}
            </div>
          } @else if (!crudform.controls['tokenValue_' + i].valid && !crudform.submitted) {
            <div class="validation-instruction">
              {{ "SEQUENTIALTOKENSETUP_VALIDADION" | translate }}
            </div>
          } @else if (crudform.submitted && crudform.controls['tokenValue_' + i].invalid) {
            <div class="validation-error">
              {{ "CLEARCREDITSETUP_STSTOKEN" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
          }
          <div class="row m-0" *ngIf="model.tokens.length > 1">
            <div class="col-md-12 d-flex align-items-center justify-content-end clear"
              (click)="removeToken(i)">
              <svg-icon src="assets/settings/trash-can-red.svg"></svg-icon>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="form-item">
      <span class="form-label"></span>
      <div class="form-input d-flex justify-content-end">
        <button class="button-add-token ps-3 pe-3" (click)="addToken()" [class.disabled]="!canAddToken">
          {{ "ADD_ANOTHER_TOKEN" | translate }} +
        </button>
      </div>
    </div>

    <div class="horizontal-line"></div>

    <div class="form-item-button">
      <button class="button-submit" [disabled]="crudform.invalid || model.tokens.length < 2" type="submit">
        {{ "LOAD_TOKENS" | translate }}
      </button>
    </div>
  </form>
</div>
